/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliInvitationPreviewDto } from '../../models/amoxcalli-invitation-preview-dto';

export interface ApiInvitationsPreviewGet$Plain$Params {
  token?: string;
}

export function apiInvitationsPreviewGet$Plain(http: HttpClient, rootUrl: string, params?: ApiInvitationsPreviewGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliInvitationPreviewDto>> {
  const rb = new RequestBuilder(rootUrl, apiInvitationsPreviewGet$Plain.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliInvitationPreviewDto>;
    })
  );
}

apiInvitationsPreviewGet$Plain.PATH = '/api/invitations/preview';
